<mat-card appearance="outlined">
    <mat-card-content class="workbench-tasks-mat-card-content" style="background-color: #fff;">
        <!-- No Tasks -->
        <div *ngIf="dataLoaded && tasks.length === 0" class="no-tasks">
            <div class="empty-state-content">
                <mat-icon class="empty-state-icon">assignment</mat-icon>
                <p class="message">No Tasks Added Yet</p>
                <mrs-btn-primary class="add-first-task-btn" buttonLabel="Add Task" buttonId="addFirstTask"
                    [disabled]="(tasks.length > 0 && tasks[0].id?.startsWith('temp-')) || (filterValue?.trim()?.length > 0)"
                    (onClick)="handleAddTaskClick()" iconName="add">
                </mrs-btn-primary>
            </div>
        </div>

        <!-- Tasks List -->
        <div [style.display]="dataLoaded && tasks.length > 0 ? 'block' : 'none'">
            <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 1rem;">
                <mat-form-field id="filter" class="filter-cases" floatLabel="never" appearance="fill"
                    style="width: 22rem">
                    <input matInput placeholder="Search" [(ngModel)]="filterValue" (input)="searchTasks()"
                        name="filterValue">
                    <mat-icon aria-hidden="false" aria-label="Search" matSuffix>
                        search
                    </mat-icon>
                </mat-form-field>
                <div class="flex flex-column">                            
                    <mrs-btn-icon class="float-end" style="margin-left: auto;" buttonLabel="Add Task" buttonId="addButton"
                    [disabled]="(tasks.length > 0 && tasks[0].id?.startsWith('temp-')) || (filterValue?.trim()?.length > 0)"
                    (onClick)="handleAddTaskClick()" iconName="add"></mrs-btn-icon>
                </div>
            </div>
        <ng-container [style.display]="dataLoaded && tasks.length !== 0 ? 'block' : 'none'">
            
            <form #myForm="ngForm">
            <table mat-table class="workbench-tasks-table" [dataSource]="dataSource" cdkDropList
                (cdkDropListDropped)="handleSortChange($event)" cdkDropListData="dataSource">
                <!-- Task Column -->
                <ng-container matColumnDef="order">
                    <th mat-header-cell *matHeaderCellDef ></th>
                    <td mat-cell *matCellDef="let task" style="padding-left: 25px !important;">
                        <div class="flex flex-column" style="align-items: center; width: 80px;">
                            <div class="flex flex-row" style="align-items: flex-start; gap: 8px;">
                                <!-- Left column: Up, Drag, Down -->
                                <div class="flex flex-column" style="align-items: center;">
                                    <!-- Up Arrow -->
                                    <button mat-icon-button [disabled]="task.sortOrder === 1 || task.id?.startsWith('temp-') || filterValue !== ''"
                                        (click)="handleMoveUp(task); $event.stopPropagation()" title="Move Up"
                                        style="width: 28px; height: 28px; margin-bottom: 0px; display: flex; justify-content: center; align-items: flex-start;">
                                        <mat-icon style="font-size: 14px;">keyboard_arrow_up</mat-icon>
                                    </button>

                                    <!-- Drag Handle -->
                                    <mat-icon class="example-drag-cursor" cdkDragHandle
                                        style="margin: 1px 0; cursor: grab;"
                                        [style.cursor]="task.id?.startsWith('temp-') ? 'not-allowed' : 'grab'">drag_indicator</mat-icon>

                                    <!-- Down Arrow -->
                                    <button mat-icon-button
                                        [disabled]="task.sortOrder === tasks.length || task.id?.startsWith('temp-') || filterValue !== ''"
                                        (click)="handleMoveDown(task); $event.stopPropagation()" title="Move Down"
                                        style="width: 28px; height: 28px; margin-top: 1px; display: flex; justify-content: center; align-items: center;">
                                        <mat-icon style="font-size: 14px;">keyboard_arrow_down</mat-icon>
                                    </button>
                                </div>

                                <!-- Right side: Position Input aligned with drag handle -->
                                <div style="margin-top: 15px;"> <!-- Offset to align with drag handle position -->
                                    <mat-form-field appearance="outline" style="width: 60px;" class="position-input">
                                        <input matInput type="number" [disabled]="task.id?.startsWith('temp-') || filterValue !== ''"
                                            [value]="task.sortOrder" min="1" [max]="tasks?.length || 1" step="1"
                                            (blur)="handleMoveToPosition(task, +$event.target.value); $event.stopPropagation()"
                                            (input)="clampPositionValue($event)"
                                            (keydown)="$event.key === 'e' || $event.key === 'E' || $event.key === '-' || $event.key === '+' || $event.key === '.' ? $event.preventDefault() : null"                                           
                                            (click)="$event.stopPropagation()" title="Position"
                                            style="text-align: center; font-size: 16px; border-bottom: solid 1px !important;">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </td>

                </ng-container>
                <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef  class="header-label">Name</th>
                    <td mat-cell *matCellDef="let task" >
                        <div class="flex flex-row w-100">
                                <mat-form-field appearance="fill" class="w-100">
                                    <mat-label>Name</mat-label>
                                    <input matInput [value]="task.name" [name]="task.id" required  [(ngModel)]="task.name" #item="ngModel"
                                        (blur)="showNameHelper.delete(task.id); onNameChange(task, $event.target.value, item)"
                                        (focus)="showNameHelper.add(task.id); originalTaskNames.set(task.id, task.name)"
                                        placeholder="Name"> 
                                    <mat-hint *ngIf="showNameHelper.has(task.id)" class="helper-text">Changing the name will only affect new applications.</mat-hint>
                                    <mat-error *ngIf="item.invalid && item.touched && invalidTaskIds.has(task.id)" class="error-message">Name is required and must be unique.</mat-error>
                                </mat-form-field>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="rule">
                    <th mat-header-cell *matHeaderCellDef  class="header-label">Rule</th>
                    <td mat-cell *matCellDef="let task" >
                        <div class="flex flex-row w-100">
                            <mat-form-field appearance="fill" class="w-100">
                                <mat-label>Rule</mat-label>
                                <mat-select [value]="task.ruleId || noRule.id" [disabled]="task.id?.startsWith('temp-')"
                                    (selectionChange)="onRuleChange(task, $event.value)">
                                    <mat-option *ngFor="let rule of rules" [value]="rule.id">
                                        {{rule.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </td>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef ></th>
                    <td mat-cell *matCellDef="let task" >
                        <div style="margin-left: auto;padding-right: 10px;">
                            <!-- Actions -->
                            <button mat-icon-button (click)="handleDeleteTask(task); $event.stopPropagation()"
                                title="Delete Task" style="align-self: flex-end; color: #d32f2f;">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                    </td>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky: true" class="header-row"></tr>
                <tr mat-row *matRowDef="let row; columns: columnsToDisplay;" cdkDrag [cdkDragData]="row" [cdkDragDisabled]="(tasks.length > 0 && tasks[0].id?.startsWith('temp-'))  || filterValue !== '' "></tr>
            </table>
            
            </form>
        </ng-container>

        <mat-paginator #paginator [pageSize]="5" [pageSizeOptions]="[5, 10, 25, 100]" showFirstLastButtons></mat-paginator>        
        </div>
        
    </mat-card-content>
</mat-card>
